import { formEmptyDefault } from "@/modules/oportunidades/constants/formEmptyDefault";

export default {
  relatorios: [],
  relatorio_oportunidades: {
    filtros: formEmptyDefault(),
  },
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
